module.exports = __webpack_public_path__ + "static/img/zhuanli-3.6282dbf2.png";